export type EsignatureBundleTooltipType =
  | 'noTickets'
  | 'minTickets'
  | 'mixedSelection'
  | 'notSignStage'
  | null;

export const getEsignatureBundleTooltip = (
  ticketCount: number,
  documentCount: number,
  allInSignStage: boolean,
): EsignatureBundleTooltipType => {
  if (ticketCount === 0 && documentCount > 0) {
    return 'noTickets';
  }
  if (ticketCount < 2) {
    return 'minTickets';
  }
  if (documentCount > 0) {
    return 'mixedSelection';
  }
  if (!allInSignStage) {
    return 'notSignStage';
  }
  return null;
};
